import React from 'react';
import { twMerge } from 'tailwind-merge';

const FormInput = ({
    label,
    id,
    type = 'text',
    value,
    onChange,
    placeholder,
    required = false,
    error,
    helpText,
    className = '',
    wrapperClassName = ''
}) => {
    const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');

    // Base input classes
    const baseInputClasses = `
        appearance-none
        w-full
        block
        px-3
        py-2
        border
        rounded-md
        shadow-sm
        text-sm
        placeholder-gray-400
        focus:outline-none
        focus:ring-2
        focus:ring-offset-0
        transition-colors
        ${error
            ? 'border-red-200 focus:border-red-300 focus:ring-red-300'
            : 'border-gray-200 focus:border-primary focus:ring-primary'
        }
    `;

    // Use twMerge to intelligently merge the classes
    const inputClasses = twMerge(baseInputClasses, className);
    const containerClasses = twMerge('w-full', wrapperClassName);

    return (
        <div className={containerClasses}>
            {label && (
                <label
                    htmlFor={inputId}
                    className="block text-sm font-medium text-gray-700 mb-1 ml-1"
                >
                    {label}
                    {required && <span className="text-red-500 ml-1">*</span>}
                </label>
            )}
            <div className="relative">
                <input
                    id={inputId}
                    type={type}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    required={required}
                    className={inputClasses}
                />
                {error && (
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                        <svg
                            className="h-5 w-5 text-red-500"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="8" x2="12" y2="12" />
                            <line x1="12" y1="16" x2="12.01" y2="16" />
                        </svg>
                    </div>
                )}
            </div>
            {(error || helpText) && (
                <p className={`mt-1 text-sm ${error ? 'text-red-600' : 'text-gray-500'}`}>
                    {error || helpText}
                </p>
            )}
        </div>
    );
};

export default FormInput;